import { convertUTCToLocal } from "../../lib/utils";

export const parseGameInfoFromGameId = (gid: string, tid:string) => {
  let gidnt = gid.replace('-'+gid.split('-')[gid.split('-').length - 1],'');
  let tidnl = tid.replace(gidnt.split('-')[0]+"-",'').replaceAll('-','');
  let oppdis = gidnt.replace(gidnt.split('-')[0]+"-",'').replace(tidnl,'').replaceAll('-','');
  let l = gidnt.split('-')[0].toUpperCase();
  //console.log('PARSE FROM GAMEID', oppdis)
  /*
  let regex = new RegExp(/[A-Z][a-z]+/g);
  let olm_index = -1;
  let tlm_index = -1;
  let match;
  while ((match = regex.exec(oppdis)) != null) {
    olm_index = match.index;
  }
  while ((match = regex.exec(tidnl)) != null) {
    tlm_index = match.index;
  }
  if (olm_index !== -1) {
    oppdis = oppdis.substring(0, olm_index) + " " + oppdis.substring(olm_index);
  }
  if (tlm_index !== -1) {
    tidnl = tidnl.substring(0, tlm_index) + " " + tidnl.substring(tlm_index);
  }
  */
  let regex = new RegExp(/[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g);
  if (tidnl.match(regex) != null) {
    tidnl = tidnl.match(regex)!.join(" ");
  }
  if (oppdis.match(regex) != null) {
    oppdis = oppdis.match(regex)!.join(" ");
  }
  //console.log('PARSE FROM GAMEID', oppdis, tidnl)
  let t1 = tidnl;
  let t2 = oppdis;
  return {
    league: l,
    team1: t1,
    team2: t2,
  }
}

export const getGameDesc = (gid: string, tid: string, t: number) => {
  const gameInfo = parseGameInfoFromGameId(gid, tid);
  console.log(`${gid} ${gameInfo.team1} vs ${gameInfo.team2} ${t}`)
  const gameTime = convertUTCToLocal(t*1000).toLocaleString(undefined, {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    //hour12: false,
    minute: '2-digit',
    //second:'2-digit'
  });
  //const gameDesc = `${gameInfo.league} ${gameInfo.team1} vs ${gameInfo.team2} ${gameTime}`;
  //const gameDesc = `${gameInfo.team1} vs ${gameInfo.team2} ${gameTime}`;
  return {
    league: `${gameInfo.league}`,
    team1: `${gameInfo.team1}`,
    team2: `${gameInfo.team2}`,
    gameTime: `${gameTime}`,
  }
}